import { User } from "../types";

/** Permission constants matching backend Resource:Action pairs. */
export const Permission = {
  ADMIN: "*:*",
  API_KEY_CREATE: "api_key:create",
  GROUP_CREATE: "group:create",
  ROLE_CREATE: "role:create",
  USER_ASSIGN_ROLE: "user:assign_role",
} as const;

/**
 * Check if a user has admin (wildcard) permissions.
 */
export function isAdmin(user: User | null | undefined): boolean {
  if (!user?.permissions?.length) return false;
  return user.permissions.includes(Permission.ADMIN);
}

/**
 * Check if a user has a specific permission.
 * Returns true for admins (wildcard) or exact match.
 */
export function hasPermission(
  user: User | null | undefined,
  permission: string,
): boolean {
  if (!user?.permissions?.length) return false;
  if (permission === Permission.ADMIN) return isAdmin(user);
  return isAdmin(user) || user.permissions.includes(permission);
}

/**
 * Check if a user has at least one of the given permissions.
 */
export function hasAnyPermission(
  user: User | null | undefined,
  permissions: string[],
): boolean {
  return permissions.some((p) => hasPermission(user, p));
}
